const pincodeInput = document.getElementById('pincodeInput');
const pincodeMsg = document.querySelector('.pincode-msg');
const applyBtn = document.querySelector('.pincode-popup #applyBtn');
const pincodeMessageWrapper = document.querySelectorAll('.pincode-messsage-wrapper');
const shiprocketPincode = document.querySelector('input[name="postal_code"]');
const pincode = getCookie('pincode')

// NEW: Function to dynamically update "Check Stock" to "In Stock"
function updateStockTextStatus(isValid = null) {
    const stockMsgElements = document.querySelectorAll('.stock-msg');
    stockMsgElements.forEach(stockMsg => {
        if (!stockMsg || stockMsg.classList.contains('out-of-stock')) return;

        if (isValid === true) {
            stockMsg.innerHTML = 'In Stock';
        } else if (isValid === false) {
            stockMsg.innerHTML = 'Check Stock';
        } else {
            const pincodeCookie = getCookie("pincode");
            if (pincodeCookie && pincodeCookie.length === 6) {
                stockMsg.innerHTML = 'In Stock';
            } else {
                stockMsg.innerHTML = 'Check Stock';
            }
        }
    });
}

function getCurrentVariantId() {
    if (window.meta && window.meta.product && window.meta.product.variants) {
        return window.meta.product.variants[0].id;
    } else if (window.ProductData && window.ProductData.variants) {
        return window.ProductData.variants[0].id;
    } else {
        const variantInput = document.querySelector('input[name="id"]');
        if (variantInput) {
            return variantInput.value;
        }
    }
    return null;
}

function checkPincodeAvailability(variantId, pincode, messageElement) {
    if (!variantId || !pincode) {
        if (messageElement) {
            messageElement.textContent = "Unable to check availability";
            messageElement.style.display = 'block';
        }
        return;
    }

    if (messageElement) {
        messageElement.textContent = "Checking availability...";

        fetchData(variantId, pincode, messageElement)

        messageElement.style.display = 'block';
    }
}
function fetchData(variantId, pincode, messageElement) {
    fetch("https://cpanel.mensabrands.com/ShiprocketETAWidget/public/checkDeliveryAvailability", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            variant_id: variantId,
            pincode: pincode
        })
    })
        .then(response => response.json())
        .then(data => {
            messageElement.innerHTML = '';

            if (data?.delivery_type[0]?.type == 'TRUE NEGATIVE') {
                messageElement.style.display = 'none';

                return;
            }

            let message = "";

            if (messageElement.classList.contains('pincode-card-msg')) {
                if (data.delivery_type[0]?.type == 'Today' || data.delivery_type[0]?.type == 'Tomorrow') {
                    messageElement.style.display = 'block';

                    renderCartData(data, variantId, messageElement, pincode);
                }
                else {
                    messageElement.style.display = 'none';
                }
            }
            else {
                renderCartData(data, variantId, messageElement, pincode);

            }
        })
        .catch(error => {
            console.log("error", error);
        });
}
function renderCartData(data, variantId, messageBox, postalCode) {
    let message = "";
    console.log("data",data)
    let delayDays = data?.delivery_type[0]?.delay_days ?? null;
    if (data.delivery_type[0]?.type == 'Today' || data.delivery_type[0]?.type == 'Tomorrow') {
        if (messageBox.classList.contains('pincode-card-msg') || messageBox.classList.contains('cart-pincode-message')) {
            messageBox.innerHTML = `Get it ${data.delivery_type[0]?.type}`;
            return;
        }
    }
    orderWithin = () => {

        let est_msg = document.querySelectorAll('.est-msg');
        let estTime = this.getRemainingHours();
        let currentTime = new Date();
        let currentTimeHour = currentTime.getHours();
        let currentTimeMinutes = currentTime.getMinutes();
        let extraMessage = '';

        // Case 1: 00:00 – 9:00
        if (currentTimeHour < 9 || (currentTimeHour === 9 && currentTimeMinutes === 0)) {
            extraMessage = `<span class="est-time">Order within ${estTime}</span>`;

            // Case 2: 9:01 – 23:59
        } else if (currentTimeHour > 9 || (currentTimeHour === 9 && currentTimeMinutes > 0)) {
            extraMessage = `<span class="est-time">Order within ${estTime}</span>`;
        }

        // let html = `Estimated Delivery By <strong>${etaDate}</strong>${extraMessage}`;
        return extraMessage
    }
    if ((data.delivery_type[0]?.type == 'Today' || data.delivery_type[0]?.type == 'Tomorrow')) {
        const cartItems = document.querySelectorAll('.cart__item_main');

        cartItems.forEach(cartItem => {
            const targetKey = cartItem.getAttribute('data-key');
            const variantIdInKey = targetKey.split(':')[0];

            // ✅ Match only the correct variant
            if (String(variantId) === variantIdInKey) {


                fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: targetKey,
                        properties: {
                            "delivery_time": data.delivery_type[0]?.type
                        }
                    })
                })
                    .then(res => res.json())
                    .then(() => {
                        console.log(`🛒 Updated delivery_time for item with key ${targetKey}`); 
                    })
                    .catch(err => {
                        console.error('❌ Error updating delivery_time:', err);
                    });

            }
        });
        let pdpCustomMsg = document.querySelectorAll('.pdp-custom-msg');
        let est_msg = document.querySelectorAll('.est-msg');
        let extraMessage = orderWithin()
        if (pdpCustomMsg && !messageBox.classList.contains('pincode-card-msg') && !messageBox.classList.contains('cart-pincode-message')) {
            let extraMessage = orderWithin()
            est_msg.forEach((msg) => {
                msg.innerHTML = `<div class="eta-msg-wrapper"> 
            <span class="success-msg">Estimated Delivery By <strong>${data.delivery_type[0]?.type}</strong></span>${extraMessage}
        </div>`;

            })
            pdpCustomMsg.forEach((msg) => {
                msg.innerHTML = `Delivery By ${data.delivery_type[0]?.type}`;
            });
            updateStockTextStatus(true); // NEW: Update stock text on success
            return;
        }
    }



    if (data.status == '404') {
        message = "Oops, it looks like we don't ship to your Pincode Try another one.";
        if (messageBox) {
            messageBox.innerHTML = `<span class="error-msg">${message}</span>`;
            messageBox.classList.add('has-error');
            messageBox.classList.remove('has-success');
            messageBox.style.display = 'block';
        }
        updateStockTextStatus(false);
    } else {
        console.log("else");
        updateStockTextStatus(true);
        // Handle regular delivery case   
        let etd = data.delivery_type[0]?.etd;
        let estimated_delivery_days =data.delivery_type[0].estimated_delivery_days;

        let storageData = {};




        storageData[variantId] = {
            postal_code: postalCode,
            var_id: variantId,
            etd: etd,
            estimated_delivery_days: estimated_delivery_days,delayDays:delayDays
        };

        setCartLocalStorage(storageData, variantId);
        renderCartPreData(variantId, messageBox,delayDays);
    }
}


// Helper method for regular local storage
function setCartLocalStorage(data, varID) {
    let shiprocketData = getCookie('shiprocketEta');
    let varID_int = parseInt(varID);
    if (shiprocketData) {
        shiprocketData = JSON.parse(shiprocketData);
        shiprocketData[varID_int] = data[varID_int];
        setCookie('shiprocketEta', JSON.stringify(shiprocketData), 1);
    } else {
        setCookie('shiprocketEta', JSON.stringify(data), 1);
    }
}


// Render cart pre-data for regular delivery
function renderCartPreData(variantId, messageBox,delayDays) {
    let shiprocketData = getCookie('shiprocketEta');
    if (shiprocketData) {
        let zipData = JSON.parse(shiprocketData);
        let varID = parseInt(variantId);
        let data = zipData[varID];

        if (data) { 
            updateStockTextStatus(true);
            let durationTime = new Date(); 
            let etaDate = new Date(data.etd);
            if (durationTime.getHours() >= 12 && (durationTime.getHours() < 24)) {
                etaDate.setDate(etaDate.getDate() + 1 + parseInt(delayDays));
            } else {
                etaDate.setDate(etaDate.getDate() + parseInt(delayDays));
            }
            let options = { weekday: 'long', day: 'numeric', month: 'long' };
            etaDate = etaDate.toLocaleDateString('en-IN', options);

            console.log("etaDate",etaDate)

            let estTime = getRemainingHours();
            let currentTime = new Date();

            let currentTimeHour = currentTime.getHours();
            let currentTimeMinutes = currentTime.getMinutes();
            let extraMessage = '';

            // Case 1: 00:00 – 9:00
            if (currentTimeHour < 9 || (currentTimeHour === 9 && currentTimeMinutes === 0)) {
                extraMessage = `<span class="est-time">Order within ${estTime}</span>`;

                // Case 2: 9:01 – 23:59
            } else if (currentTimeHour > 9 || (currentTimeHour === 9 && currentTimeMinutes > 0)) {
                extraMessage = `<span class="est-time">Order within ${estTime}</span>`;
            }

            let html = `Estimated Delivery By <strong>${etaDate}</strong>${extraMessage}`;
            // if ((currentTimeHour === 9 && currentTimeMinutes >= 0) || (currentTimeHour > 9 && currentTimeHour < 11) || (currentTimeHour === 11 && currentTimeMinutes <= 59)) {
            //     html += ` - Order within ${estTime}`;
            // }
            let pdpCustomMsg = document.querySelectorAll('.pdp-custom-msg')

             if(!messageBox.classList.contains('pincode-card-msg') && !messageBox.classList.contains('cart-pincode-message')){
            pdpCustomMsg.forEach((msg) => {
                msg.innerHTML = '';
                    msg.innerHTML = `Delivery By <strong>${etaDate}</strong>`;
                })
            }  

            if (messageBox) {
                if (messageBox.classList.contains('est-msg')) {
                    let messageBox = document.querySelectorAll('.est-msg')
                    messageBox.forEach((msg) => {
                        msg.innerHTML = html
                        msg.classList.remove('has-error');
                        msg.classList.add('has-success');
                        msg.style.display = 'block';
                    })
                    return
                }

                messageBox.innerHTML = html;

                messageBox.classList.remove('has-error');
                messageBox.classList.add('has-success');
                messageBox.style.display = 'block';
            }
        }
    }
}

function getRemainingHours() {
    const now = new Date();
    const currentHour = now.getHours();
    const currentMinutes = now.getMinutes();

    let targetTime = null;

    // Case 1: 00:00 – 09:00 → show countdown till 9:00 AM today
    if (currentHour < 9 || (currentHour === 9 && currentMinutes === 0)) {
        targetTime = new Date(now);
        targetTime.setHours(9, 0, 0, 0); // Today at 9:00 AM

        // Case 2: 09:01 – 23:59 → show countdown till 24:00 (midnight)
    } else if (currentHour > 9 || (currentHour === 9 && currentMinutes > 0)) {
        targetTime = new Date(now);
        targetTime.setDate(now.getDate() + 1); // Move to next day
        targetTime.setHours(0, 0, 0, 0); // Midnight (00:00 AM next day)
    }

    // If no valid target time, return empty
    if (!targetTime) return '';

    const diffMs = targetTime.getTime() - now.getTime();
    const diff = Math.max(diffMs, 0);
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    return `${hours} hour${hours !== 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
}


window.onload = function () {
    let icons = document.querySelectorAll('.template-product delivery-estimation .map-icon-main-wrapper .input-wrapper')

    var existingPincode = getCookie("pincode");

    if (existingPincode) {
        let product_cards = document.querySelectorAll('.product-grid .grid__item');

        // Create intersection observer
        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    let card = entry.target;

                    let productInput = card.querySelector('.product-form__input');
                    let variantId;

                    if (productInput?.querySelector('option')) {
                        variantId = productInput.querySelector('option').value;
                    } else {
                        variantId = productInput?.previousElementSibling?.value;
                    }

                    if (variantId) {
                        fetchData(variantId, existingPincode, card.querySelector('.pincode-card-msg'));
                    }

                    // Stop observing after processing
                    observer.unobserve(card);
                }
            });
        }, {
            root: null, // viewport
            threshold: 0.1 // at least 10% visible
        });

        // Observe each product card
        product_cards.forEach(card => observer.observe(card));
    }
    if (existingPincode && window.location.pathname.includes('/products/')) {

        existingPincode = getCookie('pincode')
        const currentVariantId = getCurrentVariantId();
        let eta_msg = document.querySelectorAll('.est-msg');
        eta_msg.forEach((msg) => {
            msg.innerHTML = '';
            fetchData(currentVariantId, existingPincode, msg);
        });
        let pdpCustomMsg = document.querySelectorAll('.pdp-custom-msg')
        pdpCustomMsg.forEach((msg) => {
            msg.innerHTML = '';
            fetchData(currentVariantId, existingPincode, msg);
        })
        if (document.querySelector('.quick-badge-wrapper')) {
            document.querySelector('.quick-badge-wrapper').style.display = "block";
        }
        let pincode_add = document.querySelectorAll('.pincode-add')
        let districtCookie = getCookie("district");
        // fetchData(currentVariantId, existingPincode, document.querySelector('.est-msg'));
        pincode_add.forEach((add) => {
            add.innerHTML = toTitleCase(districtCookie)
        })


        const deliveryEstimationElements = document.querySelectorAll('delivery-estimation');

        const variantInput = document.querySelector('input[name="variant_id"]');
        if (variantInput && currentVariantId) {
            variantInput.value = currentVariantId;
        }

        // Fallback: Call the function directly if available
        if (currentVariantId && existingPincode) {
            setCookie("variant_id", currentVariantId);

        }
    }
    if (window.location.pathname.includes('/products/')) {

        if (document.querySelector('.quick-badge-wrapper')) {
            document.querySelector('.quick-badge-wrapper').style.display = "block";
        }
        const notifyButton = document.querySelector('.product-block .custom-button');
        if (notifyButton) {
            notifyButton.style.display = "none";
        }
        const currentVariantId = getCurrentVariantId();
        if (currentVariantId) {
            setCookie("variant_id", currentVariantId);
        }
    }
};
function toTitleCase(str) {
 
    return str
        .toLowerCase()
        .split(" ")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}
document.addEventListener("DOMContentLoaded", () => {
    // Helper functions
    function setCookie(name, value, days = 3650) {
        const expires = new Date(Date.now() + days * 864e5).toUTCString();
        document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
    }

    function getCookie(name) {
        return document.cookie.split('; ').find(row => row.startsWith(name + '='))?.split('=')[1];
    }

    // Get existing pincode from cookie first
    let pin = getCookie("pincode");

    // Only set pincode from logged-in user if no pincode cookie exists
    let loggedInPincode = document.querySelector(".pincode-popup")?.getAttribute("pincodeno");
    if (!(getCookie("loggedinpincode"))) {
        if (loggedInPincode) {
            setCookie("pincode", loggedInPincode);
            pin = loggedInPincode;
            setCookie("loggedinpincode", true)
            // Update the input field if it exists
            let pincodeInput = document.querySelector('#pincodeInput');
            if (pincodeInput) {
                pincodeInput.value = loggedInPincode;
            }
        }
    } if (pin) {

        // Update the input field with existing cookie value
        let pincodeInput = document.querySelector('#pincodeInput');
        if (pincodeInput) {
            pincodeInput.value = pin;
        }
    }

    // Set pincode in all postal_code inputs
    document.querySelectorAll('#postal_code').forEach(input => {
        if (pin) {
            input.value = pin;
        }
    });

    // Handle pincode input changes
    const pincodeInput = document.querySelector('#pincodeInput');
    const applyBtn = document.querySelector('#applyBtn'); // Assuming you have this element

    if (pincodeInput && applyBtn) {
        applyBtn.setAttribute('disabled', 'disabled');

        pincodeInput.addEventListener('input', function (e) {
            // Only allow numbers
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
            const pincode = e.target.value;

            if (pincode.length === 6) {
                
                if (typeof fetchDistrictForPincode === 'function') {
                    fetchDistrictForPincode(pincode);
                }

            } else {
                applyBtn.setAttribute('disabled', 'disabled');
            }
        });
    }

    // Check cart items pincode availability (delayed execution)
    setTimeout(() => {
        const cartItems = document.querySelectorAll(".cart__item_main");

        cartItems.forEach(item => {
            const dataKey = item.getAttribute('data-key');
            if (!dataKey) return;

            const lineitem = dataKey.split(':');
            const variantId = lineitem[0];
            const messageBox = item.querySelector(`#pincode-message-${variantId}`);

            if (!variantId || !messageBox || !pin) return;

            // Call your pincode availability check function
            if (typeof checkPincodeAvailability === 'function') {
                checkPincodeAvailability(variantId, pin, messageBox);
            }
        });
    }, 2000);
});
// Function to get cookie value by name

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

// Function to set cookie
function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

// Function to check if device is mobile
function isMobile() {
    return window.innerWidth <= 768;
}

// Function to format district name with proper capitalization
function formatDistrictName(districtName) {
    if (!districtName) return '';

    // Convert to lowercase first, then capitalize first letter of each word
    return districtName.toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

// Function to update pincode message
function updatePincodeMessage() {
    const pincodeMessageWrappers = document.querySelectorAll('.pincode-messsage-wrapper');
    const pincodeCookie = getCookie('pincode');
    const districtCookie = getCookie("district");

    if (pincodeCookie && pincodeMessageWrappers.length > 0) {
        pincodeMessageWrappers.forEach(wrapper => {
            wrapper.style.display = "block";
            if (isMobile()) {

                // Mobile layout with "..." functionality
                const formattedDistrict = formatDistrictName(districtCookie);
                wrapper.innerHTML = `
                    <div class="pincode-message" data-district="${formattedDistrict || ''}">
                        <svg class="location-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        <span class="delivery-text">Delivering to </span>
                        <span class="pincode-number">${pincodeCookie}</span>
                        <span class="district-name">${formattedDistrict || ''}</span>
                        <svg class="dropdown-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                    </div>
                `;
                console.log("Mobile pincode message updated:", pincodeCookie, formattedDistrict);
            } else {
                // Desktop layout - show full message
                const formattedDistrict = formatDistrictName(districtCookie);
                wrapper.innerHTML = `
                    <div class="pincode-message">
                        <svg class="location-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        <span class="delivery-text">Delivering to </span>
                        <span class="pincode-number">${pincodeCookie}</span>
                        <span class="district-name">${formattedDistrict ? ' ' + formattedDistrict : ''}</span>
                    </div>
                `;
            }
        });
    }
}

// Function to handle pincode message click
function handlePincodeMessageClick() {
    const pincodeMessageWrappers = document.querySelectorAll('.pincode-messsage-wrapper');

    if (pincodeMessageWrappers.length > 0) {
        pincodeMessageWrappers.forEach(wrapper => {
            // Remove existing event listeners to prevent duplicates
            const newWrapper = wrapper.cloneNode(true);
            wrapper.parentNode.replaceChild(newWrapper, wrapper);

            // Add click handler to each wrapper
            newWrapper.addEventListener('click', function (e) {
                if (newWrapper.closest('.drawer__inner')) {
                    return;
                }
                if (isMobile()) {
                    const referButton = document.querySelector('.refer-and-earn-button');
                    if (referButton) {
                        referButton.style.bottom = "150px"
                    }
                }
                // Open pincode popup when wrapper is clicked 
                const popup = document.querySelector(".main-content .pincode-popup");
                const overlay = document.querySelector(".overlay");
                if (popup) {
                    popup.style.display = "block";
                    if (overlay) {
                        overlay.style.display = 'block';
                    }

                    // Auto-fill the pincode input field with existing pincode
                    // const pincodeInput = popup.querySelector('input[type="text"], input[name="pincode"], input[placeholder*="pincode"], input[placeholder*="PIN"]');
                    var existingPincode = getCookie("pincode");

                    if (pincodeInput && existingPincode) {
                        pincodeInput.value = existingPincode;

                        // Trigger input event to enable validation
                        pincodeInput.dispatchEvent(new Event('input', { bubbles: true }));
                    } else {
                        console.log("Pincode input not found or no existing pincode");
                    }

                } else {
                    console.error("Pincode popup element not found!");
                }
            });
        });
    }
}
function fetchDistrictForPincode(pincode, setDestrict) {

    const formData = new FormData();
    formData.append('get_pincode', pincode);

    fetch('https://cpanel.mensabrands.com/Myfitness-QuickDelivery/public/getDistrictData', {
        method: 'POST',
        body: formData,
    })
        .then(response => response.json())
        .then(data => {

            const districtName = data.district;
            const isValid = Boolean(districtName);

            // ✅ Set cookies
            if (isValid) {
                const formattedDistrict = formatDistrictName(districtName);
                console.log("set district cookie : ", formattedDistrict);

                if (setDestrict || !getCookie("district")) {
                    setCookie("district", formattedDistrict, 7300);

                }
                if (setDestrict) {
                    updateHeaderMessage(pincode);
                }
                // ✅ Update header message after setting cookie

                if (typeof applyBtn !== 'undefined') {
                    applyBtn.disabled = false;
                }
            } else {
                if (typeof applyBtn !== 'undefined') {
                    applyBtn.disabled = true;
                }
            }

            // ✅ Status message styling
            if (typeof pincodeMsg !== 'undefined') {
                pincodeMsg.classList.toggle("success-msg", isValid);
                pincodeMsg.classList.toggle("error-msg", !isValid);
                pincodeMsg.textContent = isValid
                    ? toTitleCase(districtName)
                    : data.message || "Invalid PIN code";
            }

        })
        .catch(error => {
            console.error('❌ Error fetching district:', error);
            if (typeof pincodeMsg !== 'undefined') {
                pincodeMsg.textContent = 'Failed to fetch district';
            }
            if (typeof applyBtn !== 'undefined') {
                applyBtn.disabled = true;
            }
        });
}

// ✅ Separate function to update header message
function updateHeaderMessage(pincode) {
    const pincodeMessageWrappers = document.querySelectorAll('.pincode-messsage-wrapper');
    const districtCookie = getCookie('district');


    if (!pincodeMessageWrappers.length) {
        return;
    }
    let pincode_add = document.querySelectorAll('.pincode-add')
    // let districtCookie = getCookie("district");
    // fetchData(currentVariantId, existingPincode, document.querySelector('.est-msg'));
    pincode_add.forEach((add) => {
        add.innerHTML = toTitleCase(districtCookie)
    })
    pincodeMessageWrappers.forEach(wrapper => {
        wrapper.style.display = "block";

        if (isMobile()) {
            // Mobile layout with "..." functionality
            const formattedDistrict = formatDistrictName(districtCookie);

            wrapper.innerHTML = `
                <div class="pincode-message" data-district="${formattedDistrict || ''}">
                    <svg class="location-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span class="delivery-text">Delivering to </span>
                    <span class="pincode-number">${pincode}</span>
                    <span class="district-name">${formattedDistrict || ''}</span>
                    <svg class="dropdown-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6,9 12,15 18,9"></polyline>
                    </svg>
                </div>
            `;
        } else {
            // Desktop layout - show full message
            const formattedDistrict = formatDistrictName(districtCookie);

            wrapper.innerHTML = `
                <div class="pincode-message">
                    <svg class="location-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                        <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span class="delivery-text">Delivering to </span>
                    <span class="pincode-number">${pincode}</span>
                    <span class="district-name">${formattedDistrict ? ' ' + formattedDistrict : ''}</span>
                </div>
            `;
        }
    });
}

// Initialize functions
function initializePincodeHandlers() {
    updatePincodeMessage();
    handlePincodeMessageClick();
    const popup = document.querySelector(".pincode-popup");
    const closepopup = document.querySelector('.pincode_close_popup');
    let icons = document.querySelectorAll('.template-product delivery-estimation .map-icon-main-wrapper .input-wrapper')

    // Close popup on click
    closepopup.addEventListener('click', () => {
        if (popup) {
            popup.style.display = "none";
            overlay.style.display = 'none'
        }
    });

    if (window.location.pathname.includes('/products')) {
        var customMsg  = document.querySelector('.review-container .pdp-custom-msg')
        if(customMsg)
        {
            customMsg.style.display = "block";
        }
            console.log("icons: ", icons);
        icons.forEach((icon) => {
            console.log("icon: ", icon);
            icon.addEventListener('click', () => {
                // console.log("clicked", icon);
                var pincode = getCookie('pincode')
                popup.style.display = "block";
                popup.querySelector('#pincodeInput').value = pincode;
                overlay.style.display = "block";
                document.querySelector('#applyBtn').removeAttribute('disabled');
            });
        });
    }
 
    const applyBtn = document.querySelector(".pincode-popup .apply-btn");
    const inputField = document.querySelector(".pincode-popup input");
    console.log("pincode input: ", inputField);
    const pincodeMessageWrappers = document.querySelectorAll('.pincode-messsage-wrapper');
    if (applyBtn && inputField) {
        applyBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();           
            
            const pincode = pincodeInput.value;
            console.log("button clicked");
            console.log("pincode value: ", pincode);

            if (pincode.length === 6) {

                setCookie("pincode", pincode);
                pin = pincode; // Update local variable
                console.log("updated pin : ",pin);

                // Call your pincode validation function with setDistrict=true to force update
                if (typeof fetchDistrictForPincode === 'function') {
                    fetchDistrictForPincode(pincode, true);
                }

                // Update all postal_code inputs with new pincode
                document.querySelectorAll('#postal_code').forEach(input => {
                    input.value = pincode;
                });

                // Close popup
                if (typeof popup !== 'undefined' && typeof overlay !== 'undefined') {
                    popup.style.display = "none";
                    overlay.style.display = "none";
                }
                let pincode_add = document.querySelectorAll('.pincode-add')
                let districtCookie = getCookie("district");
                console.log("district cookie: ", districtCookie);
                // fetchData(currentVariantId, existingPincode, document.querySelector('.est-msg'));
                pincode_add.forEach((add) => {
                    add.innerHTML = toTitleCase(districtCookie)
                })
                // Update delivery estimation elements
                const deliveryEstimationElements = document.querySelectorAll('delivery-estimation');
                deliveryEstimationElements.forEach(element => {
                    const pincodeCookie = getCookie('pincode');
                    const districtCookie = getCookie("district");
                    // console.log("pincode cookie value: ", pincodeCookie);
                    // console.log("district cookie value: ", districtCookie);
                    const postalCodeInput = element.querySelector('#postal_code');
                    const pincodeAddElement = element.querySelector('.pincode-add');

                    if (postalCodeInput) {
                        postalCodeInput.value = pincodeCookie;
                    }
                    if (pincodeAddElement && districtCookie) {
                        pincodeAddElement.innerHTML = toTitleCase(districtCookie);
                    }
                });

                // Handle product cards
                const productCards = document.querySelectorAll('.product-grid .grid__item');

                // Setup the observer
                const observer = new IntersectionObserver((entries, obs) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            const card = entry.target;
                            let variantId;
                            const productFormInput = card.querySelector('.product-form__input');

                            if (productFormInput) {
                                const option = productFormInput.querySelector('option');
                                if (option) {
                                    variantId = option.value;
                                } else {
                                    variantId = productFormInput.previousElementSibling?.value;
                                }

                                if (variantId && typeof fetchData === 'function') {
                                    fetchData(variantId, pincode, card.querySelector('.pincode-card-msg'));
                                }
                            }

                            obs.unobserve(card);
                        }
                        });
                    }, {
                        root: null,
                        rootMargin: '0px',
                        threshold: 0.25
                });
                productCards.forEach(card => observer.observe(card));
                let variantid = getCookie("variant_id");
                let eta_msg = document.querySelectorAll('.est-msg');
                eta_msg.forEach((msg) => {
                    if (typeof fetchData === 'function') {
                        fetchData(variantid, pincode, msg);
                    }
                });

                if (window.location.pathname.includes('/products/')) {
                    if (typeof getCurrentVariantId === 'function') {
                        const currentVariantId = getCurrentVariantId();
                        const notifyButton = document.querySelector('.product-block .custom-button');

                        if (notifyButton) {
                            notifyButton.style.display = "none";
                        }

                        if (currentVariantId && pincode) {
                            setCookie("variant_id", currentVariantId);
                            const msgBox = document.querySelector('.pincode-message');

                            if (typeof checkPincodeAvailability === 'function') {
                                checkPincodeAvailability(currentVariantId, pincode, msgBox);
                            }
                        }
                    }
                }

            } else {
                alert("Please enter a valid 6-digit PIN code.");
                 updateStockTextStatus(false);
            }
        });
    }

    // handleApplyButtonClick();
    updateStockTextStatus(); 
}

// Run the function when DOM is loaded
document.addEventListener('DOMContentLoaded', initializePincodeHandlers);

// Also run immediately in case DOM is already loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePincodeHandlers);
} else {
    initializePincodeHandlers();
}

// Handle window resize to update layout when switching between mobile and desktop
window.addEventListener('resize', function () {
    // Debounce resize events to prevent excessive calls
    clearTimeout(window.resizeTimeout);
    window.resizeTimeout = setTimeout(function () {
        initializePincodeHandlers();
    }, 250);
});
document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener('cart:updated', function (event) {
        setTimeout(() => {
            if (document.querySelector('#CartDrawer').classList.contains('drawer--is-open')) {
                const cartItems = document.querySelectorAll(".cart__item_main");

                // Hide popup
                const popup = document.querySelector('.pincode-popup');
                if (popup) {
                    popup.style.display = 'none';
                }

                cartItems.forEach(item => {
                    var lineitem = item.getAttribute('data-key');
                    if (!lineitem) return;

                    var parts = lineitem.split(':');
                    var variantId = parts[0];

                    const messageBox = item.querySelector(`#pincode-message-${variantId}`);
                    var existingPincode = getCookie("pincode");

                    if (!variantId || !messageBox || !existingPincode) return;

                    fetchData(variantId, existingPincode, messageBox)
                });
            }
        }, 1000);
    });
}); 